module.exports = {"420203007":"章山街道","420203008":"八泉街道","420203009":"澄月街道","420203010":"牧羊湖街道","420203011":"黄思湾街道","420203400":"冶钢农场","420203402":"西塞山工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420203.json
// module id = 1835
// module chunks = 0